import React from 'react'
import { Box } from '@mui/material'
import { EmotionConfig } from '../../config/emotionConfig'

export interface EmotionSphereProps {
  /**
   * Emotion configuration (image path)
   */
  emotionConfig: EmotionConfig
}

/**
 * EmotionSphere - Simple visualization with PNG emotion image
 *
 * Features:
 * - PNG emotion image (71x71px)
 */
export const EmotionSphere: React.FC<EmotionSphereProps> = ({ emotionConfig }) => {
  const { imagePath } = emotionConfig

  return (
    <Box
      component="img"
      src={imagePath}
      alt={emotionConfig.labelKey}
      sx={{
        width: '71px',
        height: '71px',
        objectFit: 'contain'
      }}
    />
  )
}

export default EmotionSphere
